

const lang={
    en:{
        search:"Search",
        GptSearchPlaceholder:"what would you like to watch today?",
    },
    hindi:{
        search:"ढूँढ",
        GptSearchPlaceholder:"आप आज क्या देखना चाहेंगे?",
    },
    spanish:{
        search:"buscar",
        GptSearchPlaceholder:"¿Qué te gustaría ver hoy?",
    }
}
export default lang